import { Button } from '@/shared/components/ui/Button';
import { Badge } from '@/shared/components/ui/Badge';
import { AdminTable } from './AdminTable';
import type { Location } from '../services/locationsService';

interface LocationsTableProps {
  locations: Location[];
  onEdit: (location: Location) => void;
  isLoading?: boolean;
}

export function LocationsTable({
  locations,
  onEdit,
  isLoading = false,
}: LocationsTableProps) {
  const columns = [
    {
      key: 'name',
      header: 'Name',
      sortable: true,
      render: (location: Location) => (
        <div className="font-medium">{location.name}</div>
      ),
    },
    {
      key: 'short_code',
      header: 'Short Code',
      sortable: true,
      render: (location: Location) => (
        <div className="font-mono">{location.short_code}</div>
      ),
    },
    {
      key: 'is_active',
      header: 'Status',
      sortable: true,
      render: (location: Location) => (
        <Badge variant={location.is_active ? 'success' : 'neutral'}>
          {location.is_active ? 'Active' : 'Inactive'}
        </Badge>
      ),
    },
    {
      key: 'created_at',
      header: 'Created',
      sortable: true,
      render: (location: Location) => (
        <div className="text-gray-500">
          {new Date(location.created_at).toLocaleDateString()}
        </div>
      ),
    },
    {
      key: 'actions',
      header: 'Actions',
      render: (location: Location) => (
        <Button
          size="sm"
          variant="ghost"
          onClick={() => onEdit(location)}
        >
          Edit
        </Button>
      ),
    },
  ];

  return (
    <AdminTable
      data={locations}
      columns={columns}
      isLoading={isLoading}
      emptyMessage="No locations found"
    />
  );
}
